import React from 'react';
import useOnTextEditorScroll from 'components/text-editor/components/controls/hooks/use-on-text-editor-scroll';
import useCustomEditor from 'components/text-editor/hooks/use-custom-editor';
import useEventListener from 'hooks/use-event-listener';
import { notEqual } from 'utils/js';
import { Node } from 'slate';

export default function useAnnotationMarkPositionStyles(
  node: Node,
  position?: 'left' | 'right',
) {
  const editor = useCustomEditor();
  const [styles, setStyles] = React.useState<any>({});

  React.useEffect(() => {
    updateStyles();
  }, [editor.selection]);

  useEventListener('resize', updateStyles);

  useOnTextEditorScroll(updateStyles);

  function updateStyles() {
    if (node) {
      const newStyles = getSlateNodePositionStyles(node, position);

      if (newStyles && notEqual(newStyles, styles)) {
        setStyles(newStyles);
      }
    }
  }

  return styles;
}

function rectToStyles(
  rect: DOMRect,
): {
  top: number;
  left: number;
  width: number;
  height: number;
} {
  return {
    top: rect.top,
    left: rect.left,
    width: rect.width,
    height: rect.height,
  };
}

function getSlateNodePositionStyles(
  node: any,
  position?: 'left' | 'right',
): React.CSSProperties | undefined {
  const elementRect = [...document.getElementsByClassName(node.annotationId)]
    // @ts-ignore
    .reduce<any>(
      (rect, element) =>
        rect.width > element.getBoundingClientRect().width
          ? rect
          : element.getBoundingClientRect(),
      [...document.getElementsByClassName(node.annotationId)],
    );

  const [textEditor] = document.getElementsByClassName('text-editor');

  const textEditorRect = textEditor?.getBoundingClientRect();

  const styles: any = rectToStyles(elementRect);

  if (textEditorRect) {
    styles.top -= textEditorRect.top;
    styles.left -= textEditorRect.left;

    if (position === 'right') {
      styles.marginLeft = styles.width;
    }

    styles.width = 'auto';

    delete styles.top;

    return styles;
  }

  return {};
}
